import RestrictedUserRoute from "discourse/routes/restricted-user";
export default RestrictedUserRoute.extend({
  setupController(controller, model) {
    controller.set("model", model);
  }
});